<template>
  <v-app class="custom__bg mt-1">
    <v-container>
      <v-row>
        <!-- Left Sidebar -->
        <v-col cols="12" md="3" lg="3">
          <v-col cols="12" class="py-1">
            <v-card class="text-center premium-card animate-fadeInUp" max-width="300">
              <v-card-text>
                <v-avatar size="70" class="elevation-2" style="border: 2px solid #f69227">
                  <img :src="$root.store.getUserAvatar()" alt="Profile Picture" />
                </v-avatar>
                <div class="mt-3 black--text">
                  <h2 style="font-size: 17px; font-weight: 700">{{ $root.storeState.currentUser.name || 'Student' }}</h2>
                  <p style="font-size: 12px; color: #707070">{{ $root.storeState.currentUser.school || 'Not specified' }}</p>
                </div>
                
                <div class="mt-4">
                  <v-btn
                    rounded block height="44" color="#f69227"
                    class="white--text text-capitalize hover-scale"
                    elevation="2"
                    @click="uploadDialog = true"
                  >
                    <v-icon left small>mdi-upload</v-icon>
                    Share Lecture
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" class="mt-2 hidden-sm-and-down">
            <v-card class="premium-card text-center pa-4" style="background: linear-gradient(135deg, #f0f2f5 0%, #e0e5ec 100%)">
              <v-icon size="48" color="grey lighten-1">mdi-advertisements</v-icon>
              <h4 class="mt-2 grey--text text--darken-1">Advertisement</h4>
            </v-card>
          </v-col>
        </v-col>

        <!-- Main Content (Lectures) -->
        <v-col cols="12" md="9" lg="9">
          <v-col cols="12" class="py-1">
            <div class="d-flex align-center justify-space-between mb-4 px-2">
              <h2 style="font-size: 22px; font-weight: 700; color: #333">Shared Lectures</h2>
              <v-btn-toggle v-model="filter" rounded mandatory color="#f69227" class="elevation-1">
                <v-btn value="all" small class="text-capitalize">All</v-btn>
                <v-btn value="mine" small class="text-capitalize">My Lectures</v-btn>
              </v-btn-toggle>
            </div>

            <div v-for="(item, index) in lectures" :key="index" class="mb-5">
              <v-card class="premium-card-elevated animate-fadeInUp" :class="'delay-' + ((index % 4) + 1)">
                <v-card-text class="pa-5">
                  <v-row no-gutters class="mb-2">
                    <v-card-subtitle class="ma-0 pa-0">
                      <span style="color: #43a047; font-weight: 700; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px">
                        {{ item.subject }}
                      </span>
                    </v-card-subtitle>
                    <v-spacer></v-spacer>
                    <v-card-subtitle class="ma-0 pa-0">
                      <span class="grey--text text--darken-1" style="font-size: 12px; font-weight: 500">
                        {{ item.level }}
                      </span>
                    </v-card-subtitle>
                  </v-row>
                  
                  <v-divider class="mb-3"></v-divider>
                  
                  <div class="d-flex align-start justify-space-between mb-2">
                    <h3 style="font-size: 18px; color: #333; line-height: 1.4; max-width: 90%">{{ item.title }}</h3>
                    <v-menu bottom left offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" class="mt-n1 mr-n2">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense class="py-0">
                        <v-list-item link>
                          <v-list-item-icon class="mr-2"><v-icon small>mdi-bookmark-outline</v-icon></v-list-item-icon>
                          <v-list-item-title style="font-size: 13px">Save</v-list-item-title>
                        </v-list-item>
                        <v-list-item link v-if="item.isMine">
                          <v-list-item-icon class="mr-2"><v-icon small color="orange">mdi-pencil-outline</v-icon></v-list-item-icon>
                          <v-list-item-title style="font-size: 13px">Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item link v-if="item.isMine">
                          <v-list-item-icon class="mr-2"><v-icon small color="error">mdi-delete-outline</v-icon></v-list-item-icon>
                          <v-list-item-title style="font-size: 13px; color: #ff5252">Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                  
                  <div class="mb-3">
                    <span style="font-size: 14px; color: #555; line-height: 1.6;">
                      {{ item.description }}
                    </span>
                  </div>
                  
                  <div class="mb-3 d-flex align-center flex-wrap">
                    <v-chip
                      v-for="(tag, tagIdx) in item.tags" :key="tagIdx"
                      class="mr-2 mb-2" color="#f0f2f5" text-color="#555" small style="font-weight: 500"
                    >
                      {{ tag }}
                    </v-chip>
                  </div>
                  
                  <!-- File Attachment -->
                  <div class="mb-4">
                    <v-card outlined rounded="lg" class="d-flex align-center pa-2 hover-item" style="background-color: #fafbfc; border-color: #e0e0e0; cursor: pointer" @click="downloadFile(item.file.name)">
                      <v-avatar size="40" :color="getFileColor(item.file.type)" class="rounded-lg mr-3">
                        <v-icon color="white">{{ getFileIcon(item.file.type) }}</v-icon>
                      </v-avatar>
                      <div class="flex-grow-1 overflow-hidden">
                        <div class="font-weight-bold text-truncate" style="font-size: 14px; color: #333">{{ item.file.name }}</div>
                        <div class="grey--text caption">{{ item.file.size }} &bull; {{ item.file.type.toUpperCase() }}</div>
                      </div>
                      <v-btn icon color="primary" class="hover-scale"><v-icon>mdi-download</v-icon></v-btn>
                    </v-card>
                  </div>
                  
                  <v-divider class="my-3"></v-divider>

                  <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center">
                      <v-avatar size="32" class="mr-2">
                        <img :src="item.author.avatar" :alt="item.author.name" />
                      </v-avatar>
                      <div class="d-flex flex-column">
                        <span style="font-size: 13px; font-weight: 600; color: #333;">{{ item.author.name }}</span>
                        <span style="font-size: 11px; color: #777;">{{ item.timeAgo }}</span>
                      </div>
                    </div>
                    
                    <div class="d-flex align-center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="grey--text d-flex align-center mx-2" style="font-size: 13px">
                            <v-icon x-small class="mr-1">mdi-download</v-icon> {{ item.stats.downloads }}
                          </span>
                        </template>
                        <span>Downloads</span>
                      </v-tooltip>
                      
                      <v-btn icon small class="mx-1 hover-scale" color="grey darken-1">
                        <v-img width="20" height="20" src="../assets/applaud.svg" alt="applaud" style="opacity: 0.7" />
                      </v-btn>
                      <span class="grey--text" style="font-size: 13px; margin-left: -4px; margin-right: 8px">{{ item.stats.applauds }}</span>
                      
                      <v-btn small icon class="hover-scale" color="grey darken-1">
                        <v-icon size="18">mdi-share-variant</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-col>
      </v-row>
    </v-container>

    <!-- Upload Dialog -->
    <v-dialog v-model="uploadDialog" max-width="600" persistent>
      <v-card class="premium-card">
        <v-card-title class="headline d-flex align-center py-4 px-5">
          <span style="font-weight: 700; font-size: 20px">Share a Lecture</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="uploadDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <v-form ref="uploadForm">
            <v-row>
              <v-col cols="12" class="py-1">
                <div class="upload-dropzone mb-4 d-flex flex-column align-center justify-center">
                  <v-icon size="48" color="#f69227" class="mb-2">mdi-cloud-upload-outline</v-icon>
                  <h4 style="color: #333">Drag and drop file here</h4>
                  <p class="caption grey--text mb-3">PDF, DOCX, PPTX or MP4 up to 50MB</p>
                  <v-btn outlined rounded color="#f69227" small class="text-capitalize px-4">Browse Files</v-btn>
                </div>
              </v-col>
              <v-col cols="12" class="py-1">
                <v-text-field label="Title" placeholder="Enter lecture title" outlined dense rounded color="#f69227"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <v-select :items="['Mathematics', 'Physics', 'Chemistry', 'Biology']" label="Subject" outlined dense rounded color="#f69227"></v-select>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <v-select :items="['Secondary', 'Tertiary', 'Postgraduate']" label="Level" outlined dense rounded color="#f69227"></v-select>
              </v-col>
              <v-col cols="12" class="py-1">
                <v-textarea label="Description" placeholder="Briefly describe what this lecture covers..." outlined dense rounded rows="3" color="#f69227"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text class="text-capitalize px-4" @click="uploadDialog = false" rounded>Cancel</v-btn>
          <v-btn color="#f69227" class="white--text text-capitalize px-6" rounded elevation="2" @click="uploadLecture" :loading="isUploading">Upload</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    filter: 'all',
    uploadDialog: false,
    isUploading: false,
    lectures: [
      {
        subject: "Mathematics",
        level: "Tertiary",
        title: "Advanced Calculus: Integration Techniques",
        description: "Comprehensive notes covering integration by parts, trigonometric integrals, and partial fractions. Includes 20 worked examples from past exams.",
        tags: ["Calculus", "Integration", "University Level"],
        file: { name: "Calculus_Integration_Notes.pdf", size: "2.4 MB", type: "pdf" },
        author: { name: "Prof. Ibrahim Sani", avatar: "https://randomuser.me/api/portraits/men/55.jpg" },
        timeAgo: "3 hours ago",
        isMine: false,
        stats: { downloads: 142, applauds: 56 }
      },
      {
        subject: "Physics",
        level: "Senior Secondary",
        title: "Thermodynamics Summary & Formulas",
        description: "A quick cheat sheet for thermodynamics covering the zeroth, first, and second laws. Great for WAEC/NECO revision.",
        tags: ["Thermodynamics", "WAEC", "Formulas"],
        file: { name: "Thermodynamics_CheatSheet.docx", size: "845 KB", type: "doc" },
        author: { name: this.$root.storeState.currentUser.name || 'Student', avatar: this.$root.store.getUserAvatar() },
        timeAgo: "1 day ago",
        isMine: true,
        stats: { downloads: 89, applauds: 24 }
      },
      {
        subject: "Computer Science",
        level: "Tertiary",
        title: "Data Structures: Binary Trees",
        description: "Lecture slides on Binary Search Trees, AVL Trees, and traversal algorithms (In-order, Pre-order, Post-order).",
        tags: ["Data Structures", "Trees", "Algorithms"],
        file: { name: "Lecture_04_BinaryTrees.pptx", size: "4.1 MB", type: "ppt" },
        author: { name: "Grace Okafor", avatar: "https://randomuser.me/api/portraits/women/65.jpg" },
        timeAgo: "2 days ago",
        isMine: false,
        stats: { downloads: 315, applauds: 112 }
      }
    ]
  }),
  methods: {
    getFileIcon(type) {
      const icons = { 'pdf': 'mdi-file-pdf-box', 'doc': 'mdi-file-word-box', 'ppt': 'mdi-file-powerpoint-box', 'mp4': 'mdi-file-video' };
      return icons[type] || 'mdi-file-document';
    },
    getFileColor(type) {
      const colors = { 'pdf': '#e53935', 'doc': '#1e88e5', 'ppt': '#fb8c00', 'mp4': '#43a047' };
      return colors[type] || '#757575';
    },
    downloadFile(filename) {
      this.$root.showSnackbar(`Downloading ${filename}...`, "#2089d6", "mdi-download");
    },
    uploadLecture() {
      this.isUploading = true;
      setTimeout(() => {
        this.isUploading = false;
        this.uploadDialog = false;
        this.$root.showSnackbar("Lecture shared successfully!", "#43a047", "mdi-check-circle");
      }, 1500);
    }
  }
};
</script>

<style scoped>
.custom__bg {
  background: #f5f5f5;
  min-height: 100vh;
}
.hover-item {
  transition: all 0.2s ease;
}
.hover-item:hover {
  background-color: #f0f2f5 !important;
  border-color: #c0c0c0 !important;
}
.upload-dropzone {
  border: 2px dashed #e0e0e0;
  border-radius: 12px;
  background-color: #fafbfc;
  padding: 30px 20px;
  transition: all 0.3s ease;
}
.upload-dropzone:hover {
  border-color: #f69227;
  background-color: #fff9f2;
}
</style>
